import { useQuery } from "@apollo/client";
import { SelectChangeEvent } from "@mui/material";
import i18next from "i18next";
import React from "react";

import { settingsQuery } from "../home/Home.gql";
import { getSettings, getUserId } from "../utils/localStorage";

export const useSettings = () => {
    const lastSetting = getSettings();
    const [initialValues, setInitialValues] = React.useState(lastSetting);
    const [setting, setSetting] = React.useState("");

    const { data } = useQuery(settingsQuery, {
        variables: {
            userId: getUserId(),
        },
        fetchPolicy: "network-only",
    });

    React.useEffect(() => {
        if (data?.settings) {
            setSetting(data.settings.length === 0 && !lastSetting ? "" : data.settings.length);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [data]);

    const selectOptions =
        data && lastSetting ? [...data.settings, { ...lastSetting, name: i18next.language === "de" ? "Letzte Einstellung" : "Last setting" }] : [];

    const handleChange = (event: SelectChangeEvent) => {
        setSetting(event.target.value as string);
        const setting = selectOptions[parseInt(event.target.value)];
        setInitialValues({ ...setting, discreet: setting.discreet ? "yes" : "no", favourite: setting.favourite ? "yes" : "no" });
    };

    return {
        setting,
        selectOptions,
        initialValues,
        handleChange,
    };
};
